import React, { useState, useEffect } from 'react';
import { Button, Box, ButtonGroup, Typography, TableContainer, Table, TableHead, TableBody, TableRow, TableCell, Paper} from '@mui/material';
import Sidebar from '../../components/sidebar';
import Header from '../../components/header';
import { useNavigate } from 'react-router-dom';
import CustomPopup from "../../components/popup/CustomPopup";
import TagsInput from "../../components/TagsInput"
import userService from '../../services/user_service';
import userConstants from '../../constants/user_constants';
import EditIcon from '@mui/icons-material/Edit';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';

const ManagementTrainerPage = () => {
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [trainers, setTrainers] = useState(0);
  const [visibility, setVisibility] = useState(false);
  const [visibilityAdd, setVisibilityAdd] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [visibilityForm, setVisibilityForm] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [visibilityBookingList, setVisibilityBookingList] = useState(false);
  const [bookingList, setBookingList] = useState([]);
  const [visibilityMemberList, setVisibilityMemberList] = useState(false);
  const [memberList, setMemberList] = useState([]);
  const [visibilityDetails, setVisibilityDetails] = useState(false);
  const [specialty, setSpecialty] = useState([]);
  const [certification, setCertification] = useState([]);
  const [loadingTrainerDetails, setLoadingTrainerDetails] = useState(false);
  const [visibilitySpecialtyEdit, setVisibilitySpecialtyEdit] = useState(false);
  const [visibilityCertificationEdit, setVisibilityCertificationEdit] = useState(false);
  const [specialtyFormData, setSpecialtyFormData] = useState([]);
  const [certificationFormData, setCertificationFormData] = useState([]);
  const [visibilitySpecialtyAdd, setVisibilitySpecialtyAdd] = useState(false);
  const [visibilityCertificationAdd, setVisibilityCertificationAdd] = useState(false);
  const [addSpecialtyData, setAddSpecialtyData] = useState([]);
  const [addCertificationData, setAddCertificationData] = useState([]);
  const [rows, setRows] = useState([{ value: '' }]);
  const [rowsCertification, setRowsCertification] = useState([{ value: '' }]);
  const [visibilityDescriptionEdit, setVisibilityDescriptionEdit] = useState(false);
  const [trainerData, setTrainerData] = useState([]);
  const [descriptionInput, setDescriptionInput] = useState('');
  const [loadingBookingList, setLoadingBookingList] = useState(false);

  const [formData, setFormData] = useState({
   name: "",
   email: "",
   phone: "",
  });


  const popupCloseHandler = () => {
    setVisibility(false);
  };

  const popupCloseHandlerForm = () => {
    setVisibilityForm(false);
  };

    const handleSaveClick = async (userId, formData) => {
      setIsSaving(true);
      try {
        const response = await userService.updateOneUser(userId, formData);
        if (response.status === 200) {
          setUsers(prevUsers => {
            const updatedUsers = prevUsers.map(user => {
              if (user.id === selectedUser.id) {
                return { ...user, ...response.data };
              }
              return user;
            });
            return updatedUsers;
          });
          setSelectedUser(null);
          setVisibilityForm(false);
        } else {
          console.error(response.message);
        }
        setIsSaving(false);
      } catch (error) {
        console.error(error);
        setIsSaving(false);
      }
    };

    const handleBookClick = async (userId, user) => {
      setLoadingBookingList(true);
      try {
        const response = await userService.getAllTrainerBookingList();

        const trainerDataResponse = await userService.getAllTrainer();
        const getTrainerDataByUserId = trainerDataResponse.data.find(trainer => trainer.user_id === userId);
        const trainerId = getTrainerDataByUserId.id;

        const filteredBookings = response.data.filter(booking => booking.personal_trainer_id === trainerId);

        const memberIds = filteredBookings.map(booking => booking.member_id);
        const memberDataResponse = await userService.getAllMember();
        const memberData = memberDataResponse.data.filter(member => memberIds.includes(member.id));

        const userIds = memberData.map(member => member.user_id);
        const userDataResponse = await userService.getAllUser();
        const userData = userDataResponse.data.filter(userFromMember => userIds.includes(userFromMember.id));

        setBookingList(filteredBookings);
        setMemberList(userData);
        setVisibilityBookingList(true);
        setVisibilityMemberList(true);
        setLoadingBookingList(false);
      } catch (error) {
        console.error(error);
        setLoadingBookingList(false);
      }
    };

    const fetchTrainerDetails = async (userId) => {
      setLoadingTrainerDetails(true);
      try {
        const trainerDataResponse = await userService.getAllTrainer();
        const getTrainerDataByUserId = trainerDataResponse.data.find(trainer => trainer.user_id === userId);
        const trainerId = getTrainerDataByUserId.id;

        const response = await userService.getAllPtDetails();
        const trainerDetailsData = response.data.filter(trainerDetails =>trainerDetails.personal_trainer_id === trainerId);
        setSpecialtyFormData(trainerDetailsData.filter(trainerDetail => trainerDetail.type === 1));
        setCertificationFormData(trainerDetailsData.filter(trainerDetail => trainerDetail.type === 2));

        const specialtyValues = trainerDetailsData
        .filter(trainerDetail => trainerDetail.type === 1)
        .map(trainerDetail => trainerDetail.name);

        const certificationValues = trainerDetailsData
        .filter(trainerDetail => trainerDetail.type === 2)
        .map(trainerDetail => trainerDetail.name);

        setSpecialty(specialtyValues);
        setCertification(certificationValues);
        setLoadingTrainerDetails(false);

      } catch (error) {
        console.error(error);
        setLoadingTrainerDetails(false);
      }
    };

    const handleSpecialtySave = async (specialtyFormData) => {
      setIsSaving(true);
      try {
        for (const dataItem of specialtyFormData) {
          const response = await userService.updatePtDetails(dataItem.id, { name: dataItem.name });
        }
        setVisibilitySpecialtyEdit(false);
        setIsSaving(false);
      } catch (error) {
        console.error(error);
        setIsSaving(false);
      }
    };

    const handleDeleteSpecialty = async (id) => {
      try {
        const response = await userService.deletePtDetails(id);
        if (response.status === 200) {
          setSpecialtyFormData((prevFormData) =>
            prevFormData.filter((item) => item.id !== id)
          );
        } else {
          console.error(response.message);
        }
      } catch (error) {
        console.error(error);
      }
    };

    const handleAddSpecialty = async (specialtyNames, userId) => {
      setIsSaving(true);
      try {
        const trainerDataResponse = await userService.getAllTrainer();
        const getTrainerDataByUserId = trainerDataResponse.data.find(trainer => trainer.user_id === userId);
        const trainerId = getTrainerDataByUserId.id;

        if (specialtyNames.length !== 0) {
          for (const specialtyName of specialtyNames) {
            console.log(specialtyName);
            console.log(specialtyNames);
              if (specialtyName !== ""){
                const response = await userService.addPtDetails({
                  personal_trainer_id: trainerId,
                  name: specialtyName,
                  type: 1,
                });
              }
          }
          setVisibilitySpecialtyAdd(false);

        }
        setAddSpecialtyData(['']);
        setRows(['']);
        setIsSaving(false);
      } catch (error) {
        console.error(error);
        setIsSaving(false);
      }
    };

    const handleInputChange = (e, index) => {
      const { value } = e.target;
      setAddSpecialtyData((prevData) => {
        const updatedData = [...prevData];
        updatedData[index] = value;
        return updatedData;
      });
      console.log(addSpecialtyData);
    };

    const handleAddField = () => {
      setRows(prevRows => [...prevRows, { value: '' }]);
    };

    const handleRemoveField = (index) => {
        if (rows.length >= 2){
          setRows(prevRows => prevRows.filter((_, i) => i !== index));

          setAddSpecialtyData(prevData => {
            const updatedData = [...prevData];
            updatedData.splice(index, 1); // Remove the value at the specified index
            return updatedData;
          });}

    };

    const hasOnlyNullStrings = addSpecialtyData.every(item => item === null || item === '');

    const handleCertificationSave = async (certificationFormData) => {
      setIsSaving(true);
      try {
        for (const dataItem of certificationFormData) {
          const response = await userService.updatePtDetails(dataItem.id, { name: dataItem.name });
        }
        setVisibilityCertificationEdit(false);
        setIsSaving(false);
      } catch (error) {
        console.error(error);
        setIsSaving(false);
      }
    };

    const handleDeleteCertification = async (id) => {
      try {
        const response = await userService.deletePtDetails(id);
        if (response.status === 200) {
          setCertificationFormData((prevFormData) =>
            prevFormData.filter((item) => item.id !== id)
          );
        } else {
          console.error(response.message);
        }
      } catch (error) {
        console.error(error);
      }
    };

    const handleAddCertification = async (certificationNames, userId) => {
      setIsSaving(true);
      try {
        const trainerDataResponse = await userService.getAllTrainer();
        const getTrainerDataByUserId = trainerDataResponse.data.find(trainer => trainer.user_id === userId);
        const trainerId = getTrainerDataByUserId.id;

        if (certificationNames.length !== 0) {
          for (const certificationName of certificationNames) {
            console.log(certificationNames);
            console.log(certificationNames);
              if (certificationName !== ""){
                const response = await userService.addPtDetails({
                  personal_trainer_id: trainerId,
                  name: certificationName,
                  type: 2,
                });
              }
          }
          setVisibilityCertificationAdd(false);

        }
        setAddCertificationData(['']);
        setRowsCertification(['']);
        setIsSaving(false);
      } catch (error) {
        console.error(error);
        setIsSaving(false);
      }
    };

    const handleInputChangeCertification = (e, index) => {
      const { value } = e.target;
      setAddCertificationData((prevData) => {
        const updatedData = [...prevData];
        updatedData[index] = value;
        return updatedData;
      });
      console.log(setAddCertificationData);
    };

    const handleAddFieldCertification = () => {
      setRowsCertification(prevRows => [...prevRows, { value: '' }]);
    };

    const handleRemoveFieldCertification = (index) => {
        if (rowsCertification.length >= 2){
        setRowsCertification(prevRows => prevRows.filter((_, i) => i !== index));}

        setAddCertificationData(prevData => {
           const updatedData = [...prevData];
           updatedData.splice(index, 1);
           return updatedData;
        });};


    const hasOnlyNullStringsCertification = addCertificationData.every(item => item === null || item === '');

    const fetchTrainerData = async (userId) => {
        const trainerDataResponse = await userService.getAllTrainer();
        const getTrainerDataByUserId = trainerDataResponse.data.find(trainer => trainer.user_id === userId);
        const trainerId = getTrainerDataByUserId.id;


        const trainerDetailsData = trainerDataResponse.data.filter(trainerData =>trainerData.id === trainerId);

        setTrainerData(trainerDetailsData);
        setDescriptionInput(trainerDetailsData[0]?.description);
        console.log(trainerId);
        console.log(trainerDetailsData);
        console.log(trainerData);
    };


    const handleSaveDescription = async (trainerId, description) => {
      setIsSaving(true);
      try {
        const response = await userService.updatePt(trainerId,{
//           id: trainerId,
          description: description,
        });
        if (response.status === 200) {
          console.log("Description updated successfully");
          setVisibilityDescriptionEdit(false);
        } else {
          console.error(response.message);
        }
        setDescriptionInput('');
        setIsSaving(false);
      } catch (error) {
        console.error(error);
        setIsSaving(false);
      }
    };



  const fetchUsers = async () => {
    try {
      const response = await userService.getAllUser();
      setUsers(response.data);
    } catch (error) {
      console.error(error);
    }

  };

  useEffect(() => {
    fetchUsers();
  }, []);


  return (
    <>
      <Box sx={{ top: 0, left: 0, width: '100%', zIndex: 2 }}>
        <Header />
      </Box>
      <Box sx={{ position: 'absolute', top: 64, left: 0, height: '100%', zIndex: 2 }}>
        <Sidebar activeButton="Personal Trainer" />
      </Box>
      <Typography sx={{ fontFamily: 'Titillium Web', marginLeft: '280px', mt: 2, fontWeight: 'bold' }} variant="h6" component="h3" color="#1C1C1E" mb={1}>
        Manajemen Personal Trainer
      </Typography>
      <Box sx={{ left: 280, boxShadow: 5, textTransform: 'none', mb: 2 }}>
      </Box>
      <Box sx={{ marginLeft: '280px', marginRight: '10px' }} display="flex" justifyContent="space-between" mb={2}>
        <TableContainer component={Paper} sx={{ fontFamily: 'Titillium Web', maxHeight: '600px' }}>
          <TableHead>
            <TableRow>
              <TableCell>User ID</TableCell>
              <TableCell>Nama</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>Nomor Telepon</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {users
              .filter(user => user.role === userConstants.userRoleConstants.PERSONAL_TRAINER)
              .map(user => (
                <TableRow key={user.id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                  <TableCell>{user.id}</TableCell>
                  <TableCell>{user.name}</TableCell>
                  <TableCell>{user.email}</TableCell>
                  <TableCell>{user.phone}</TableCell>
                  <TableCell>
                    <ButtonGroup variant="outlined" aria-label="outlined button group">
                      <Button variant="contained"
                        onClick={() => {
                          setSelectedUser(user);
                          setVisibilityForm(true);
                          setFormData({ // Prefill the form data with user data
                            name: user.name,
                            email: user.email,
                            phone: user.phone,
                          });
                        }}
                      >
                        Edit
                      </Button>

                      <Button
                        variant="contained"
                        onClick={() => {
                            handleBookClick(user.id, user);
                            setVisibilityMemberList(true);
                        }}
                      >
                        Booking List
                      </Button>

                      <Button
                        variant="contained"
                        onClick={() => {
                            setSelectedUser(user);
                            fetchTrainerDetails(user.id);
                            setVisibilityDetails(true);
                            fetchTrainerData(user.id);
                        }}
                      >
                        View Details
                      </Button>


                    </ButtonGroup>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </TableContainer>

        <CustomPopup
          onClose={popupCloseHandlerForm}
          show={visibilityForm && selectedUser !== null}
          title={"Edit Trainer"}
        >
          {isSaving ? (
              <Typography variant="body1">Saving...</Typography>
            ) : (
              <>
              <form>
                <label>
                     Name:
                     <div className="tags-input-container">
                     <input
                       type="text"
                       value={formData.name}
                       onChange={(e) =>
                         setFormData((prevData) => ({ ...prevData, name: e.target.value }))
                       }
                     />
                     </div>
                 </label>

                <label>
                     Email:
                     <div className="tags-input-container">
                     <input
                       type="email"
                       value={formData.email}
                       onChange={(e) =>
                         setFormData((prevData) => ({ ...prevData, email: e.target.value }))
                       }
                     />
                     </div>
                </label>

                <label>
                     Phone Number:
                     <div className="tags-input-container">
                     <input
                       type="tel"
                       value={formData.phone}
                       onChange={(e) =>
                         setFormData((prevData) => ({ ...prevData, phone: e.target.value }))
                       }
                     />
                     </div>
                 </label>

                <Button
                  variant="contained"
                  onClick={() => handleSaveClick(selectedUser.id, formData)}
                >
                  Save
                </Button>
              </form>

            </>
          )}
        </CustomPopup>

        <CustomPopup
          onClose={() => setVisibilityMemberList(false)}
          show={visibilityMemberList}
          title="Booking List"
        >
          {loadingBookingList ? (
              <Typography variant="body1">Loading...</Typography> // Display the loading text
            ) : (
              <>
                <div>
                  {memberList.length > 0 ? (
                    <ol>
                      {memberList.map((member) => (
                        <li key={member.id}>
                          <p><span style={{ fontWeight: 'bold' }}>ID: </span>{member.id}</p>
                            <p><span style={{ fontWeight: 'bold' }}>Member Name: </span>{member.name}</p>
                            <p><span style={{ fontWeight: 'bold' }}>Member Email: </span>{member.email}</p>
                            <p><span style={{ fontWeight: 'bold' }}>Member Phone: </span>{member.phone}</p>
                        </li>
                      ))}
                    </ol>
                  ) : (
                    <p>No bookings available.</p>
                  )}
                </div>
            </>
          )}

        </CustomPopup>

        <CustomPopup
          onClose={() => setVisibilityDetails(false)}
          show={visibilityDetails}
          title={"Trainer Details"}

        >
          {loadingTrainerDetails ? (
              <Typography variant="body1">Loading...</Typography>
            ) : (
            <>

              <div>
                <div>
                    <div className="specialty-container">
                      <p><span style={{ fontWeight: 'bold' }}>Specialty: </span></p>
                      <IconButton
                        onClick={() => {
                          setVisibilityDetails(false);
                          setVisibilitySpecialtyEdit(true);
                        }}
                      >
                        <EditIcon />
                      </IconButton>

                      <IconButton
                        onClick={() => {
                          setVisibilityDetails(false);
                          setVisibilitySpecialtyAdd(true);
                        }}
                      >
                        <AddIcon />
                      </IconButton>
                    </div>

                  <div className="tags-container">
                      {specialty && specialty.length > 0 ? (
                        specialty.map((tag, index) => (
                          <div key={index} className="tag-item-with-margin">{tag}</div>
                        ))
                      ) : (
                          <p>No tags available.</p>

                      )}
                  </div>
                </div>

                <div>
                    <div className="specialty-container">
                      <p><span style={{ fontWeight: 'bold' }}>Certification: </span></p>
                      <IconButton
                        onClick={() => {
                          setVisibilityDetails(false);
                          setVisibilityCertificationEdit(true);
                        }}
                      >
                        <EditIcon />
                      </IconButton>

                      <IconButton
                        onClick={() => {
                          setVisibilityDetails(false);
                          setVisibilityCertificationAdd(true);
                        }}
                      >
                        <AddIcon />
                      </IconButton>
                    </div>

                  <div className="tags-container">
                      {certification && certification.length > 0 ? (
                        certification.map((tag, index) => (
                          <div key={index} className="tag-item-with-margin">{tag}</div>
                        ))
                      ) : (
                          <p>No tags available.</p>

                      )}
                  </div>
                </div>

                <div>
                    <div className="specialty-container">
                      <p><span style={{ fontWeight: 'bold' }}>Description: </span></p>
                      <IconButton
                        onClick={() => {
                          setVisibilityDetails(false);
                          setVisibilityDescriptionEdit(true);
                          fetchTrainerData(selectedUser.id);
                        }}
                      >
                        <EditIcon />
                      </IconButton>
                    </div>

                  <div>
                    <div >

                        {trainerData && trainerData.length > 0 ? (
                          trainerData[0].description !== null ? (
                            <div>{trainerData[0].description}</div>
                          ) : (
                            <p>No description available.</p>
                          )
                        ) : null}
                    </div>
                  </div>
                </div>

               </div>
            </>
          )}

        </CustomPopup>

        <CustomPopup
          onClose={() => setVisibilitySpecialtyEdit(false)}
          show={visibilitySpecialtyEdit}
          title={"Edit Specialty"}
        >
          {isSaving ? (
              <Typography variant="body1">Saving...</Typography> // Display the loading text
            ) : (
              <>

              <form>
                {specialtyFormData.map((item, index) => {
                  return (
                    <div key={item.id}>

                      <input
                        type="text"
                        value={item.name}
                        onChange={(e) => {
                          const updatedSpecialties = [...specialtyFormData];
                          updatedSpecialties[index].name = e.target.value;
                          setSpecialtyFormData(updatedSpecialties);
                        }}
                      />

                          <IconButton
                            onClick={() => handleDeleteSpecialty(item.id)}
                          >
                            <DeleteIcon />
                          </IconButton>
                    </div>
                  );
                })}
                      <Button
                        variant="contained"
                        onClick={() => handleSpecialtySave(specialtyFormData)}
                      >
                        Save
                      </Button>
              </form>
            </>
          )}
        </CustomPopup>

        <CustomPopup
          onClose={() => setVisibilityCertificationEdit(false)}
          show={visibilityCertificationEdit}
          title={"Edit Certification"}
        >
          {isSaving ? (
              <Typography variant="body1">Saving...</Typography> // Display the loading text
            ) : (
              <>
              <form>
                {certificationFormData.map((item, index) => {
                  return (
                    <div key={item.id}>

                      <input
                        type="text"
                        value={item.name}
                        onChange={(e) => {
                          const updatedCertifications = [...certificationFormData];
                          updatedCertifications[index].name = e.target.value;
                          setCertificationFormData(updatedCertifications);
                        }}
                      />

                          <IconButton
                            onClick={() => handleDeleteCertification(item.id)}
                          >
                            <DeleteIcon />
                          </IconButton>
                    </div>
                  );
                })}
                      <Button
                        variant="contained"
                        onClick={() => handleCertificationSave(certificationFormData)}
                      >
                        Save
                      </Button>
              </form>
            </>
          )}
        </CustomPopup>



        <CustomPopup
          onClose={() => {
            setVisibilitySpecialtyAdd(false);
            setAddSpecialtyData(['']);
            setRows(['']);
          }}
          show={visibilitySpecialtyAdd}
          title={"Add Specialty"}
        >
          {isSaving ? (
            <Typography variant="body1">Saving...</Typography>
          ) : (
            <>
              <form>
                  {rows.map((row, index) => (

                    <div key={index}>
                      <input
                        type="text"
                        value={addSpecialtyData[index]}
                        onChange={(e) =>
                          handleInputChange(e, index)}

                      />

                      <IconButton
                          variant="contained"
                          onClick={() => handleRemoveField(index)}
                          disabled={rows < 1}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </div>

                  ))}
                  <IconButton variant="contained" onClick={handleAddField}>
                    <AddIcon />
                  </IconButton>

                  <Button
                    variant="contained"
                    onClick={() => handleAddSpecialty(addSpecialtyData, selectedUser.id)}
                    disabled={hasOnlyNullStrings || addSpecialtyData.length === 0 || isSaving}
                  >
                    Save
                  </Button>
                </form>
              </>
          )}


        </CustomPopup>


        <CustomPopup
          onClose={() => {
            setVisibilityCertificationAdd(false);
            setAddCertificationData(['']);
            setRowsCertification(['']);
          }}
          show={visibilityCertificationAdd}
          title={"Add Certification"}
        >
          {isSaving ? (
            <Typography variant="body1">Saving...</Typography>
          ) : (
            <>
              <form>
                {rowsCertification.map((row, index) => (

                  <div key={index}>
                    <input
                      type="text"
                      value={addCertificationData[index]}
                      onChange={(e) =>
                        handleInputChangeCertification(e, index)}

                    />

                    <IconButton
                        variant="contained"
                        onClick={() => handleRemoveFieldCertification(index)}
                        disabled={rowsCertification < 1}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </div>

                ))}
                <IconButton variant="contained" onClick={handleAddFieldCertification}>
                  <AddIcon />
                </IconButton>

                <Button
                  variant="contained"
                  onClick={() => handleAddCertification(addCertificationData, selectedUser.id)}
                  disabled={hasOnlyNullStringsCertification || addCertificationData.length === 0 || isSaving}
                >
                  Save
                </Button>
              </form>
            </>
          )}
        </CustomPopup>


        <CustomPopup
          onClose={() => {
            setVisibilityDescriptionEdit(false);
            setDescriptionInput('');
          }}
          show={visibilityDescriptionEdit}
          title={"Edit Description"}

        >
          {isSaving ? (
            <Typography variant="body1">Saving...</Typography>
          ) : (
            <>
              <form>
                <div>
                  <textarea
                    type="text"
                    value={descriptionInput}
                    onChange={(e) => setDescriptionInput(e.target.value)}
                    rows={6}
                    wrap="soft"
                    className="custom-textarea"
                  />
                </div>
                <Button
                  variant="contained"
                  onClick={() => handleSaveDescription(trainerData[0].id, descriptionInput)}
                >
                  Save
                </Button>
              </form>
            </>
          )}
        </CustomPopup>

      </Box></>
  );
};

export default ManagementTrainerPage;